/**
 * ページスクロールをボタンを表示するコンポーネント
 */
export default {
    // see resources/views/components/_vue_page_scroll.blade.php
    name: 'pageScroll',
    template: '#page_scroll_component_template',
    methods: {
        // ページ最上部へ
        top: function () {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        },
        // ページ最下部へ
        bottom: function () {
            const element = document.documentElement;
            const bottom = element.scrollHeight - element.clientHeight;
            window.scrollTo({
                top: bottom,
                behavior: 'smooth'
            });
        }
    }
};